module.exports = __webpack_public_path__ + "img/logout-icon.2f50034e.svg";